<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <div class="activity-div" v-if="dataList==null">
          <div class="activity-div2">
            <img src="@/assets/publicImg/stay-tuned.png" alt />
            <div class="title-div">敬请期待！</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  props: ['checkLi'],
  data() {
    return {
      page: 1,//当前页
      size: 10,//每页条数
      total: 0,//总数据条数
      finishedText:'没有更多了',
      loading: false,//将 loading 设置为 true，表示处于加载状态
      finished: false,//是否已加载完成，加载完成后不再触发load事件
      refreshing: false,
      dataList: [],
    }
  },
  methods: {
    //下拉刷新
    onRefresh() {
      this.page = 1
      this.finished = false
      this.loading = true;
      this.getData()
    },
    onLoad() {//初始加载
      this.getData()
    },
    //数据
    getData() {
      let that = this
      let data = {
        userId: localStorage.getItem('userid'),
        typeCode: that.checkLi,//system系统消息,business业务,activity活动
        page: that.page,
        size: that.size
      }
      that.$fetchGet(URLTB.getMessage.url, data).then(res => {
        if (res.data.code == 20000) {
          that.refreshing = false
          that.loading = false
          let list = res.data.data.data.records
          that.total = res.data.data.data.total
          that.messageCount = res.data.data.unread
          if (list == null || list.length == 0) {
            //加载结束
            that.finished = true
            that.dataList=null
            that.finishedText=''
            return
          }
          //将新数据与老数据进行合并
          if (that.page > 1) {
            that.dataList = [...that.dataList, ...list]
          } else {
            that.dataList = list
          }
          //如果列表数据条数>=总数据条数，不再触发loading加载
          if (that.size * that.page >= that.total) {
            that.finished = true
            return
          }
          //如果如果列表数据条数<总数据条数,页数加一
          if (that.size * that.page < that.total) {
            that.page++
          }
        }

      })
    },
  }

}
</script>

<style lang="less" scoped>
.activity-div {
  height: calc(100vh - 35px);
  background: #fff;
  overflow: scroll;
  text-align: center;
  position: relative;
  .activity-div2 {
    position: absolute;
    width: 375px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 251px;
      height: 210px;
    }
    .title-div {
      margin-top: 30px;
      font-family: Source Han Sans CN;
      font-size: 15px;
      font-weight: 500;
      color: #333333;
    }
  }
}
</style>